<style scoped>
li {
  list-style: none;
}
.top {
  color: #333333;
  font-size: 0.17rem;
  padding-bottom: 0.49rem;
  padding-top: 0.1rem;
}
.banner,
.hot_list {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  margin-top: 0.15rem;
  margin-bottom: 0.15rem;
}
.banner li {
  flex: 1;
  font-size: 0.14rem;
  color: #333333;
  text-align: center;
}
.icon1,
.icon2,
.icon3,
.icon4 {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
.tl_info {
  margin-top: 0.05rem;
}
.title {
  color: #333333;
  font-size: 0.16rem;
  margin-left: 10px;
}
.line {
  display: inline-block;
  width: 3px;
  height: 12px;
  background: rgba(80, 109, 246, 1);
  margin-right: 5px;
}
.hot_list {
  margin: 0.2rem 0.1rem;
}
.hot_list li {
  flex: 1;
  border-bottom: 1px solid #eee;
  position: relative;
  /* padding-left: 0.1rem; */
  flex: 0.49;
}
.line_box {
  background: #eeeeee;
  margin-bottom: 0.1rem;
}
.li_line {
  display: inline-block;
  width: 1%;
  height: 100%;
  background: #eee;
  margin-bottom: 0.1rem;
}
.box .con {
  margin-left: 0.1rem;
  position: relative;
  width: 70%;
  top: 0.03rem;
}
.box li.noPad {
  padding-left: 0;
  margin-right: 0.1rem;
}
.box .time {
  font-size: 0.12rem;
  color: #999999;
  clear: both;
  overflow: hidden;
  margin-bottom: 0.14rem;
  margin-top: 0.05rem;
}
.box .money {
  color: #ee6c67;
  font-size: 0.16rem;
  clear: both;
  overflow: hidden;
}
.box .name {
  color: #333333;
  font-size: 0.14rem;
}
.box .logo {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  background: url('../../assets/img/newpage/icon3.png') no-repeat center center;
  background-size: 100%;
}
.box .repayment {
  height: 0.15rem;
  float: right;
}
.box .hot,
.box .limit,
.box .lowinterest,
.box .largernum,
.box .brand {
  color: #ff0000;
  font-size: 0.12rem;
  background: #ffe3e3;
  padding: 0.01rem 0.02rem;
  float: right;
  right: 0;
  border-radius: 2px;
}
.box .limit {
  color: rgba(255, 172, 72, 1);
  background: rgba(255, 241, 212, 1);
}
.box .lowinterest {
  color: #339999;
  background: #d3f4f4;
}
.box .brand {
  color: #663399;
  background: #eddbff;
}
.box .largernum {
  color: #ffe9da;
  background: #ff6600;
}
.m1 {
  margin-left: 0.1rem;
}
.banner_box img {
  /* background: url("../../assets/img/newpage/banner.png") no-repeat center center; */
  /* background-size: 100%; */
  width: 100%;
  height: 1rem;
  margin-bottom: 0.1rem;
}
.box {
  width: 100%;
  clear: both;
  overflow: hidden;
}
.box .item {
  width: 50%;
  padding-left: 0.1rem;
  border-bottom: 1px solid #eee;
  padding-top: 0.15rem;
  border-right: 1px solid #eee;
  height: 1rem;
}
.noBorder {
  border-right: none;
}
</style>
<template>
  <div class="market"
       style="height:100%;">
    <div id="mescroll"
         class="mescroll noticeBox"
         ref="mescroll">
      <div>
        <div class="top">
          <div class="top_money">
            <ul class="banner">
              <li v-for="(item, idx) in appRecommendResps"
                  :key="idx"
                  @click="classTypeClick(item,6)">
                <img class="icon1"
                     :src="item.iconUrl"
                     alt="">
                <p class="tl_info">{{item.name}}</p>
              </li>

            </ul>
            <div class="banner_box"
                 @click="bannerClick"
                 v-if="status == 1">
              <img :src="imgUrl"
                   alt="">
            </div>
            <h3 class="title"><span class="line"></span>精选贷款</h3>
            <div class="box"
                 id="noticeList"
                 ref="noticeList">
              <div class="item left"
                   v-for="(item,idx) in productDetails"
                   :key="idx"
                   :class="{'noBorder':idx%2==0}"
                   @click="listClick(item,2)">
                <div class="aaa">
                  <div class="left">
                    <img :src="item.icon"
                         alt=""
                         class="logo">
                  </div>
                  <div class="left con">
                    <p class="name">
                      <span>{{item.name}}</span>
                      <!-- <span :class="{'repayment':item.tagUrls[0]}">{{item.tagUrls[0]}}</span> -->
                      <img class="repayment"
                           :src="item.tagUrls[0]"
                           alt="">
                    </p>
                  </div>
                </div>
                <p class="money">{{item.limit}}</p>
                <p class="time">{{item.lendingCycle}} | {{item.staging}}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debug } from 'util';
import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
// import Head from '@/components/Head'
export default {
  name: 'market',
  components: {
    // Head,
    MeScroll
  },
  data () {
    return {
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      noticeScrollTop: '',
      title: '新口子',
      payType: 1,
      lineType: 1,
      appAdvertisementResp: '',
      appRecommendResps: [],//热门区域
      productDetails: [],//分页数据列表
      imgUrl: '',
      json: {},
      status: '',
      showEmpty: false,//是否展示分页
      page: 1,
      pageSize: 20,
      getWindowHeight: '',
      t1: 0,
      t2: 0,
      timer: null,
      productIds: '',
      productTypes: '',
      obj: {
        productId: '',
        sign: '',
      },
    }
  },
  created () {
  },
  computed: {
    commonParams () {
      return this.$store.state.common.commonParams
    },
  },
  mounted () {
    console.log(this.commonParams)
    this.util.title("新口子")
    let json = {
      event_key: 'h5_loanmarket_view',
      os: localStorage.getItem('os'),
      app_market_channel: localStorage.getItem('appMarketChannel'),
      app_version: localStorage.getItem('appVersion'),
      customer_id: localStorage.getItem('customerId'),
      udid: localStorage.getItem('udid'),
      package_name: localStorage.getItem('packageName'),
    }
    this.toCountPoint(json)
    let _this = this;
    _this.mescroll = new MeScroll("mescroll", { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getList, //上拉回调
        page: {
          size: 20
        },
        clearEmptyId: 'noticeList',
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata">-- End --</p>',
        onScroll: function (mescroll, y, isUp) {
          _this.scrollTop = y;
          _this.noticeScrollTop = _this.$refs.noticeList.offsetTop
          _this.getWindowHeight = document.documentElement.clientHeight || document.body.clientHeight;
          // console.log(_this.getWindowHeight + '当前屏幕高度')
          // console.log(_this.scrollTop + '当前滚动条据顶部的距离')
          // console.log(_this.noticeScrollTop + '下拉列表距离顶部高度')
          // console.log(_this.productDetails)
          clearTimeout(_this.timer);
          _this.t1 = _this.exposure();
          _this.timer = setTimeout(_this.isScrollEnd, 500);
        }
      },
      down: {
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      }
    });
  },
  methods: {
    //统计埋点
    toCountPoint (json) {
      // Object.assign(this.commonParams, json)
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    bannerClick () {
      if (this.appAdvertisementResp[0].imgUrl) {
        let json = {
          event_key: 'h5_loanmarket_banner_click',
          url: this.appAdvertisementResp[0].imgUrl
        }
        this.toCountPoint(json)
      }
      this.countClickRate(this.appAdvertisementResp[0], 7)
    },
    classTypeClick (item, pagePosition) {
      let json = {
        event_key: 'h5_loanmarket_class_click',
        button_name: item.name
      }
      this.toCountPoint(json)
      this.countClickRate(item, pagePosition)
    },
    listClick (item, pagePosition) {
      let json = {
        event_key: 'h5_loanmarket_products_click',
        product_id: item.id,
        product_type: item.type,
      }
      this.toCountPoint(json)
      this.countClickRate(item, pagePosition)
    },
    numJewelsInStones (J, S) {
      //S按字母拆成数组，把J里包含的字母留下来，数组长度就是答案
      return S.split("").filter(function (i, index) {
        i => J.includes(i)
      }).length
    },
    //获取跳转链接
    getPageUrl (item, pagePosition) {
      let param = {}
      param.productId = this.obj.productId;
      param.pagePosition = pagePosition;
      this.obj.sign = this.obj.productId + 'zEf8JalypwrJAvWYbXYnvBfltrbL2Q'
      param.sign = this.$md5(this.obj.sign);
      let _this = this;
      this.$post('/app/api/v1/getUrl', param)
        .then(function (res) {
          if (res.code == 200) {
            let href = _this.util.decrypt(res.data)//对返回值进行解密
            if (res.data && href.indexOf('/vip/handleVip') >= 1) {
              href = href + "?uid=" + localStorage.getItem('customerId')
            }
            //去前筛
            if (item.isFilter == 1) {
              _this.getFileter(item, JSON.parse(href).url);
            } else {
              window.location.href = JSON.parse(href).url;
            }
            console.log(JSON.parse(href).url)
          } else {
            this.util.toast({ msg: res.message })
          }
        }).catch(function (error) { });
    },
    isScrollEnd () {
      this.t2 = this.exposure();
      if (this.t2 === this.t1) {
        // 调用曝光接口
        console.log("滚动结束了——————————调用曝光接口" + this.productIds);
        console.log("滚动结束了——————————调用曝光接口" + this.productTypes);
        let param = { num: 1, product_id: this.productIds, product_type: this.productTypes, event_key: 'h5_loanmarket_products_view' }
        this.$post('/app/api/v1/newExposure', param)
          .then(function (res) {
            if (res.code == 200) {
              console.log(res)
            } else {
              _this.util.toast({ msg: res.message })
            }
          }).catch(function (error) { });
      }
    },
    exposure () {
      this.productIds = '';
      this.productTypes = '';
      // 计算曝光量
      // 偏移量：scrollTop  屏幕高度：getWindowHeight   列表距离顶部的高度：noticeScrollTop   每条数据高度：100
      // 当偏移量<=列表距离顶部的高度——————没有分页的情况时
      let upIndex = 0;//上标
      let downIndex = 0;//下标
      if (this.scrollTop <= this.noticeScrollTop) {
        downIndex = Math.round((this.getWindowHeight - (this.noticeScrollTop - this.scrollTop)) / 100) * 2 - 1;
      } else {
        upIndex = Math.round((this.scrollTop - this.noticeScrollTop) / 100) * 2;
        downIndex = Number(Math.floor((this.getWindowHeight + this.scrollTop - this.noticeScrollTop) / 100) * 2) - 1;
      }
      for (let i = upIndex;i <= downIndex;i++) {
        if (i > this.productDetails.length - 1) {
          break
        } else {
          this.productIds += this.productDetails[i].id + ','
          this.productTypes += this.productDetails[i].type + ','
        }
        // console.log([upIndex, downIndex])
        // console.log(this.productIds.substr(0, this.productIds.length - 1));
      }
    },
    /**
            * 下拉刷新
            */
    downCallback () {
      this.productDetails = []//重置数组
      //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    getList (page) {
      let _this = this;
      let params = {
        page: page.num,//从1开始
        size: _this.pageSize,
      };
      this.$get('/app/newWeb/v1/newTwo', params)
        .then(function (res) {
          if (res.code == 200) {
            if (res.data.newOpeningPageDetail.pageNum == 1) {
              _this.appRecommendResps = [];
              _this.appAdvertisementResp = res.data.newOpeningPageDetail.appAdvertisementResp;
              if (_this.appAdvertisementResp[0].imgUrl) {
                let json = {
                  event_key: 'h5_loanmarket_banner_view',
                  url: _this.appAdvertisementResp[0].imgUrl
                }
                _this.toCountPoint(json)
              }
              res.data.newOpeningPageDetail.appRecommendResps.map(function (item, index) {
                if (item.pageUrl && item.pageUrl.indexOf('/vip/handleVip') >= 1) {
                  item.pageUrl = item.pageUrl + "?uid=" + localStorage.getItem('customerId')
                }
                _this.appRecommendResps.push(item);
              })
              _this.imgUrl = _this.appAdvertisementResp[0].imgUrl;
              if (_this.appAdvertisementResp[0].pageUrl && _this.appAdvertisementResp[0].pageUrl.indexOf('/vip/handleVip') >= 1) {
                _this.appAdvertisementResp[0].pageUrl += "?uid=" + localStorage.getItem('customerId');
              }
              _this.status = _this.appAdvertisementResp[0].status;
            }
            //产品分页
            let productList = res.data.newOpeningPageDetail.productDetails;
            _this.productDetails = _this.productDetails.concat(productList);
            _this.mescroll.endBySize(productList.length, res.data.newOpeningPageDetail.total);

          } else {
            _this.util.toast({ msg: res.message })
          }
        }).catch(function (error) {
          console.log('错误')
        });
    },
    //去跳转获取url
    countClickRate (item, pagePosition) {
      //判断登录
      if (localStorage.getItem("token") == 'undefined' || localStorage.getItem("token") == '' || localStorage.getItem("token") == null) {
        //跳转到ios的登录页面
        this.toLogin();
      } else {
        if (item.pageUrl == null || item.pageUrl == undefined || item.pageUrl == '') {//h5产品
          this.obj.productId = item.id;
          this.getPageUrl(item, pagePosition);
        } else {
          //去前筛
          if (item.isFilter == 1) {
            this.getFileter(item, item.pageUrl);
          } else {
            window.location.href = item.pageUrl;
          }
        }
      }
    },
    //用户过滤接口
    getFileter (item, pageUrl) {
      let _this = this;
      this.$get('/app/api/v1/union/can-loan', {
        productId: item.id
      })
        .then(function (res) {
          if (res.code == 200) {
            window.location.href = pageUrl;
          } else if (res.code == 4101) {//实名认证未通过
            //跳转到ios的实名认证页面
            _this.authFail();
          } else if (res.code == 4103 || res.code == 4104) {//撞库、前筛未通过
            //跳转到ios的实名认证页面
            _this.signInFail(item);
          } else {
            _this.util.toast({ msg: res.message })
          }
        }).catch(function (error) { });
    },
    //调用android和ios的方法
    authFail () {
      try {
        window.webkit.messageHandlers.authFail.postMessage('');//ios
      } catch (err) {
        window.AppJs.authFail();//android
      }
    },
    //调用android和ios的方法
    signInFail (item) {
      let json = {
        "productId": item.id
      }
      try {
        window.webkit.messageHandlers.signInFail.postMessage(json);//ios
      } catch (err) {
        window.AppJs.signInFail(JSON.stringify(json));//android
      }
    },
    //去登录
    toLogin () {
      try {
        window.webkit.messageHandlers.toLogin.postMessage('');//ios
      } catch (err) {
        window.AppJs.toLogin();//android
      }
    }
  },

}
</script>
